import { useEffect, useMemo, useState } from "react";

/**
 * Props:
 *  - label?: string
 *  - value?: string (ISO like "2025-09-21T10:00:00Z" or "")
 *  - onChange: (isoOrEmpty: string) => void
 *  - help?: string
 */
export default function DateTimePicker({ label="Starts at", value="", onChange, help }) {
  const [localVal, setLocalVal] = useState("");

  useEffect(() => {
    if (!value) { setLocalVal(""); return; }
    const d = new Date(value);
    if (isNaN(d)) { setLocalVal(""); return; }
    const pad = (n)=> String(n).padStart(2,"0");
    const y = d.getFullYear(), m = pad(d.getMonth()+1), day = pad(d.getDate());
    const hh = pad(d.getHours()), mm = pad(d.getMinutes());
    setLocalVal(`${y}-${m}-${day}T${hh}:${mm}`);
  }, [value]);

  const toIso = (str) => str ? new Date(str).toISOString() : "";

  const presets = useMemo(() => ([
    { label: "Now", at: () => new Date() },
    { label: "+1 hour", at: () => new Date(Date.now() + 60*60*1000) },
    { label: "Tomorrow 10:00", at: () => {
        const d = new Date(); d.setDate(d.getDate()+1); d.setHours(10,0,0,0); return d;
      }
    },
  ]), []);

  const applyPreset = (fn) => {
    const d = fn();
    const pad = (n)=> String(n).padStart(2,"0");
    const y = d.getFullYear(), m = pad(d.getMonth()+1), day = pad(d.getDate());
    const hh = pad(d.getHours()), mm = pad(d.getMinutes());
    const s = `${y}-${m}-${day}T${hh}:${mm}`;
    setLocalVal(s);
    onChange(new Date(s).toISOString());
  };

  return (
    <div style={{ display:"grid", gap:6 }}>
      <label>{label}</label>
      <input
        type="datetime-local"
        value={localVal}
        onChange={(e)=>{ setLocalVal(e.target.value); onChange(toIso(e.target.value)); }}
      />
      <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
        {presets.map(p => <button type="button" key={p.label} onClick={()=>applyPreset(p)}>{p.label}</button>)}
        <button type="button" onClick={()=>{ setLocalVal(""); onChange(""); }}>Clear</button>
      </div>
      <div style={{ fontSize:12, color:"#6b7280" }}>
        {help || "Shows local time; stores UTC (ISO)."}
      </div>
      {value ? <div style={{ fontSize:12 }}><strong>UTC:</strong> {value}</div> : null}
    </div>
  );
}
